import { render } from "./AssignMenuItemsModifier.vue?vue&type=template&id=7ff6fe02&scoped=true"
import script from "./AssignMenuItemsModifier.vue?vue&type=script&lang=js"
export * from "./AssignMenuItemsModifier.vue?vue&type=script&lang=js"

import "./AssignMenuItemsModifier.vue?vue&type=style&index=0&id=7ff6fe02&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff6fe02"]])

export default __exports__